import React, { useEffect, useRef, useState } from 'react';
import { IconButton, Popover, Text } from '@oneaudi/unified-web-components';
import { PopoverPriceDisclaimer, PriceRow, PriceRowLabel, PriceRowValue, } from './pricebreakdown.styles';
import { useServicesContext } from '../../../../../context';
import { needsCurrencyFormatting, replaceFootnotesInText } from '../../../../utils';
import { SYS_BREAKPOINT_MD, SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';
import { FootnoteReference } from '../../../../../components/footnotes/components/FootnoteReference';
import { useDesktopOrMobileView } from '../../../../../hooks/dom/useDesktopOrMobileView';
export const PriceGroupItemComponent = ({ priceGroupItem }) => {
    var _a, _b, _c;
    if (!priceGroupItem || priceGroupItem.price === undefined || priceGroupItem.price === null)
        return null;
    const formatter = useServicesContext().getAdditionalService('audi-number-formatter-service');
    const groupPrice = needsCurrencyFormatting(priceGroupItem.price)
        ? formatter.formatCurrency(Number(priceGroupItem.price))
        : priceGroupItem.price;
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [rowWidth, setRowWidth] = useState(0);
    const ref = useRef();
    const hasSubitems = (_a = priceGroupItem === null || priceGroupItem === void 0 ? void 0 : priceGroupItem.items) === null || _a === void 0 ? void 0 : _a.length;
    useEffect(() => {
        if (!ref.current)
            return null;
        const resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setRowWidth(entry.contentRect.width);
            }
        });
        resizeObserver.observe(ref.current);
        return () => resizeObserver.disconnect();
    }, []);
    const isMobile = useDesktopOrMobileView(SYS_BREAKPOINT_MD) === 'mobile';
    const popoverContent = (React.createElement("div", { style: { width: isMobile ? rowWidth - 32 : rowWidth * 0.8 } },
        React.createElement(Text, { tag: "p", variant: { order: '3', style: 'normal' }, margin: ['0', '0', SYS_SPACE_FIXED_100, '0'] }, priceGroupItem.priceIncludeText), (_b = priceGroupItem === null || priceGroupItem === void 0 ? void 0 : priceGroupItem.items) === null || _b === void 0 ? void 0 :
        _b.map((subPrice) => {
            if (subPrice.price === undefined || subPrice.price === null)
                return null;
            const formattedSubPrice = needsCurrencyFormatting(subPrice.price)
                ? formatter.formatCurrency(Number(subPrice.price))
                : subPrice.price;
            return (React.createElement(PriceRow, null,
                React.createElement(Text, { tag: "span", variant: { order: '2', style: 'normal' } }, replaceFootnotesInText(subPrice.label)),
                React.createElement(Text, { tag: "span", variant: { order: '2', style: 'normal' } }, formattedSubPrice)));
        }),
        ((_c = priceGroupItem === null || priceGroupItem === void 0 ? void 0 : priceGroupItem.disclaimerText) === null || _c === void 0 ? void 0 : _c.trim()) && (React.createElement(PopoverPriceDisclaimer, null,
            React.createElement(Text, { tag: "span", variant: { order: '2', style: 'normal' } }, priceGroupItem === null || priceGroupItem === void 0 ? void 0 : priceGroupItem.disclaimerText)))));
    return (React.createElement(React.Fragment, null,
        React.createElement(PriceRow, { ref: ref },
            React.createElement(PriceRowLabel, { "data-testid": "price-row-label" },
                React.createElement(Text, { tag: "p", variant: { order: '2', style: priceGroupItem.isBold ? 'bold' : 'normal' } },
                    replaceFootnotesInText(priceGroupItem.label),
                    (priceGroupItem === null || priceGroupItem === void 0 ? void 0 : priceGroupItem.priceFootnote) && (React.createElement(FootnoteReference, { refId: priceGroupItem === null || priceGroupItem === void 0 ? void 0 : priceGroupItem.priceFootnote }))),
                hasSubitems ? (React.createElement(Popover, { alignment: "left", "aria-label": "", content: popoverContent, "data-testid": "test-id", id: "example-id", role: "dialog", onClose: () => { }, placement: "bottom", triggerElement: React.createElement(IconButton, { icon: "info-circle", variant: "tertiary", size: "sm", onClick: () => {
                            setPopoverOpen(!popoverOpen);
                        } }), withTip: true, open: popoverOpen })) : null),
            React.createElement(PriceRowValue, null,
                React.createElement(Text, { "data-testid": "price-row-price", tag: "span", variant: { order: '2', style: priceGroupItem.isBold ? 'bold' : 'normal' } }, groupPrice)))));
};
